/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {KitchenDramaSushiManiaSymbol, KitchenDramaSushiManiaSymbolStates} from "./KitchenDramaSushiManiaSymbol";
import {SimpleAvalancheReelModel} from "../../core/reel/simplereel/SimpleAvalancheReelModel";
import {
    Positionable,
    SimpleReelModelDelegate,
    SimpleReelModelState,
    SimpleReelModelSymbolData,
    SimpleReelModelSymbolPosition
} from "../../core/reel/simplereel/SimpleReelModel";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {KitchenDramaSushiManiaStatics} from "../utils/KitchenDramaSushiManiaStatics";

export class KitchenDramaSushiManiaReelsView extends PIXI.Container implements StageLayer, SimpleReelModelDelegate{

    get reelModels():SimpleAvalancheReelModel[] {
        return this._reelModels;
    }
    private _reelModels:SimpleAvalancheReelModel[];
    private _symbolContainer:PIXI.Container;

    public static reelDropDelay = 0.05;

    private static DEFAULT_REEL_SET:string[] = ["L1","L2","L3","L4","M1","M2","M3","M4","W","W2"];

    constructor() {
        super();
        this.init();
    }

    private init() {

        this._symbolContainer = new PIXI.Container();
        this._symbolContainer.position.set(0, 0);

        this.addChild(this._symbolContainer);

        this._reelModels = [];
        for (let i:number = 0; i < 5; i++){
            const reel = new SimpleAvalancheReelModel(i, this, true);
            reel.setReelSet(KitchenDramaSushiManiaReelsView.DEFAULT_REEL_SET);
            reel.init(KitchenDramaSushiMania.model.data.reels[0][i].concat(), [
                {x:i * KitchenDramaSushiManiaStatics.SYMBOL_WIDTH + KitchenDramaSushiManiaStatics.REEL_X_OFFSET , y: KitchenDramaSushiManiaStatics.REEL_Y_OFFSET},
                {x:i * KitchenDramaSushiManiaStatics.SYMBOL_WIDTH + KitchenDramaSushiManiaStatics.REEL_X_OFFSET , y:KitchenDramaSushiManiaStatics.SYMBOL_HEIGHT + KitchenDramaSushiManiaStatics.REEL_Y_OFFSET},
                {x:i * KitchenDramaSushiManiaStatics.SYMBOL_WIDTH + KitchenDramaSushiManiaStatics.REEL_X_OFFSET , y:KitchenDramaSushiManiaStatics.SYMBOL_HEIGHT*2 + KitchenDramaSushiManiaStatics.REEL_Y_OFFSET},
            ]);

            this._reelModels.push(reel);
        }

        this.onResize();

    }

    onResize():void {
        for (let i:number = 0; i < this.reelModels.length; i++){
            const reel = this.reelModels[i];
            reel.setStartAndEndPositions(
                {
                    x:i * KitchenDramaSushiManiaStatics.SYMBOL_WIDTH + KitchenDramaSushiManiaStatics.REEL_X_OFFSET ,
                    y:NolimitApplication.screenBounds.top-200-KitchenDramaSushiManiaStatics.SYMBOL_HEIGHT
                },
                {
                    x:i * KitchenDramaSushiManiaStatics.SYMBOL_WIDTH + KitchenDramaSushiManiaStatics.REEL_X_OFFSET ,
                    y:NolimitApplication.screenBounds.bottom+200 + KitchenDramaSushiManiaStatics.SYMBOL_HEIGHT
                    //y:2500
                })
        }
    }

    createSymbol(symbolName:string, state:SimpleReelModelState, symbolPosition:SimpleReelModelSymbolPosition):Positionable {
        const symbolState:KitchenDramaSushiManiaSymbolStates = state == SimpleReelModelState.SPIN ? KitchenDramaSushiManiaSymbolStates.SPIN : KitchenDramaSushiManiaSymbolStates.NORMAL;
        const symbol = new KitchenDramaSushiManiaSymbol(symbolName, symbolState, symbolPosition.reelID);

        //symbol.anchor.set(0.5,0.5);

        //this._symbolContainer.addChildAt(symbol,this._symbolContainer.children.length);

        if (state == SimpleReelModelState.FILL_UP){
            this._symbolContainer.addChildAt(symbol,0);
        } else {
            this._symbolContainer.addChild(symbol);
        }
        return symbol;
    }


    removeSymbol(symbolData:SimpleReelModelSymbolData):void {
        (<KitchenDramaSushiManiaSymbol>symbolData.positionable).destroy();
    }

    getVisibleSymbolDataAt(column:number, row:number):SimpleReelModelSymbolData {
        const visibleSymbols = this._reelModels[column].getAllVisibleSymbols();
        return visibleSymbols[row];
    }

    public transformSymbolAt(column:number, row:number, toSymbol:string): {oldSymbol:SimpleReelModelSymbolData, newSymbol:SimpleReelModelSymbolData}{
        const data = this.reelModels[column].swapSymbol(toSymbol, row);
        this._symbolContainer.addChildAt(<KitchenDramaSushiManiaSymbol>data.newSymbol.positionable, this._symbolContainer.getChildIndex(<KitchenDramaSushiManiaSymbol>data.oldSymbol.positionable));
        return data;
    }

}